import { all, fork } from 'redux-saga/effects';

import feedbackQuestionsReducer from './feedbackQuestions/reducer';
import feedbackQuestionsSaga from './feedbackQuestions/saga';

import messageCounterReducer from './messageCounter/reducer';
import messageCounterSaga from './messageCounter/saga';

import messagesReducer from './messages/reducer';
import messagesSaga from './messages/saga';

import messagesFiltersReducer from './messagesFilters/reducer';

import relatedAppealsReducer from './relatedAppeals/reducer';
import relatedAppealsSaga from './relatedAppeals/saga';

import cameralAuditsReducer from './cameralAudits/reducer';
import cameralAuditsSaga from './cameralAudits/saga';

import oldVersionMessagesReducer from './messagesInOldVersion/reducer';
import oldVersionMessagesSaga from './messagesInOldVersion/saga';

export const messagesReducers = {
  messagesFilters: messagesFiltersReducer,
  messages: messagesReducer,
  messageCounter: messageCounterReducer,
  feedbackQuestions: feedbackQuestionsReducer,
  relatedAppeals: relatedAppealsReducer,
  cameralAudits: cameralAuditsReducer,
  oldVersionMessages: oldVersionMessagesReducer,
};

export function* messagesSagas() {
  yield all(
    [
      messagesSaga,
      messageCounterSaga,
      feedbackQuestionsSaga,
      relatedAppealsSaga,
      cameralAuditsSaga,
      oldVersionMessagesSaga,
    ].map(function (saga) {
      return fork(saga);
    }),
  );
}
